import { Trans } from 'react-i18next';
import { HelpLink } from '@/web/components/HelpLink';
import {
  Button,
  IconButton,
  IconCircleInfoRegular,
  TIconButtonProps,
} from '@coverflex-tech/hypernova';

interface BaseProps {
  size?: TIconButtonProps['size'];
  className?: string;
  learnMoreI18nKey?: string;
}

interface ButtonProps extends BaseProps {
  learnMoreLinkKey?: undefined;
  onClick: () => void;
}

interface HelpLinkProps extends BaseProps {
  learnMoreLinkKey: string;
  onClick?: undefined;
}

type IProps = ButtonProps | HelpLinkProps;

export const InfoButton = ({
  size,
  onClick,
  className,
  learnMoreLinkKey,
  learnMoreI18nKey = 'general.learn_more',
}: IProps) => (
  <HelpLink i18nKey={learnMoreLinkKey}>
    {learnMoreI18nKey ? (
      <Button
        className={className}
        onClick={onClick}
        data-test-id="info-button"
        variant="info"
        size={size}
        icon={<IconCircleInfoRegular />}
        presentational={!!learnMoreLinkKey}
      >
        <Trans i18nKey={learnMoreI18nKey} />
      </Button>
    ) : (
      <IconButton
        className={className}
        onClick={onClick}
        variant="info"
        size={size}
        icon={<IconCircleInfoRegular />}
        presentational={!!learnMoreLinkKey}
        // @ts-expect-error
        buttonAttributes={{ 'data-test-id': 'info-button' }}
      />
    )}
  </HelpLink>
);
